export default __webpack_public_path__ + "images/XR.44153d6.png";